import './App.css';
import { Route, Routes } from 'react-router-dom'
import DashboardLayout from './AdminPanel/Pages/DashboardLayout/DashboardLayout';
import Dashboard from './AdminPanel/Pages/Dashboard/Dashboard';
import LandingPages from './AdminPanel/Pages/LandingPages/LandingPages';
import Home from './CustomerPanel/Pages/Home/Home';
import CustomerLogin from './CustomerPanel/Pages/CustomerLogin/CustomerLogin';
import AdminLogin from './AdminPanel/Pages/AdminLogin/AdminLogin';
import Orders from './AdminPanel/Pages/Orders/Orders';
import MosollaLanding from './CustomerPanel/LandingPages/MosollaLanding/MosollaLanding';
import UnderConstruction from './CustomerPanel/Pages/UnderConstruction';
import OrderSuccess from './New folder/OrderSuccess/OrderSuccess';
import OrderDetails from './AdminPanel/Pages/OrderDetails/OrderDetails';
import ChiyaSeed from './CustomerPanel/LandingPages/ChiyaSeed/ChiyaSeed';
import TokmaDana from './CustomerPanel/LandingPages/TokmaDana/TokmaDana';



function App() {
  return (
    <>
      {/* customer panel routing section */}
      <Routes>
        <Route element={<Home></Home>}></Route>
        <Route path='/' element={<Home></Home>}></Route>
        <Route index element={<UnderConstruction></UnderConstruction>}></Route>
        <Route path='userlogin' element={<CustomerLogin></CustomerLogin>}></Route>
        <Route path='mosolla-landing-page' element={<MosollaLanding></MosollaLanding>}></Route>
        <Route path='orderSuccess' element={<OrderSuccess></OrderSuccess>}></Route>
        <Route path='chiya-seed' element={<ChiyaSeed></ChiyaSeed>}></Route>
        <Route path='tokma-dana' element={<TokmaDana></TokmaDana>}></Route>
      </Routes>


      {/* admin panel routing section here */}
      <Routes>
        <Route path='admin' element={<DashboardLayout></DashboardLayout>}>
          <Route path='/admin' index element={<Dashboard></Dashboard>}></Route>
          <Route path='landingpages' element={<LandingPages />}></Route>
          <Route path='orders' element={<Orders></Orders>}>

          </Route>
          <Route path='orders/:orderId' element={<OrderDetails></OrderDetails>}></Route>
          <Route path='adminlogin' element={<AdminLogin></AdminLogin>}></Route>

        </Route>



      </Routes>

    </>
  );
}

export default App;
